/**
 * Created by XuQiang on 2017/5/26.
 */
import request from '../utils/request';

export const getMeetingDevice = ({ domainName, locale }) => {
  const url = `/smartmeeting/smart/third/findAllDevices?domainName=${domainName}&lang=${locale}`;
  return request(url);
};

export const logOff = () => {
  return request(`/iwork/login/logout`);
};



// WEBPACK FOOTER //
// ./src/services/top.js